import React, { useState } from 'react';

const ServicesSection = ({ onOpenConsultation }) => {
  const [filter, setFilter] = useState('all');

  const services = [
    {
      id: 'custom-software',
      title: 'Custom Software Development',
      category: 'core',
      icon: 'fas fa-code-branch',
      image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80',
      description: 'Tailor-made enterprise software solutions built with scalable microservices architecture, clean code, and cloud-native engineering.',
      tags: ['Microservices', 'Cloud-Native', 'Scalable Arch'],
      color: '#6C63FF',
    },
    {
      id: 'mobile-apps',
      title: 'iOS & Android Native Mobile Apps',
      category: 'mobile',
      icon: 'fas fa-mobile-alt',
      image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80',
      description: 'High-performance native iOS and Android mobile applications built with Flutter, React Native, Swift, and Kotlin for seamless user experiences.',
      tags: ['Flutter & React Native', 'Swift & Kotlin', 'Native iOS & Android'],
      color: '#00D4FF',
    },
    {
      id: 'web-dev',
      title: 'Web Application Engineering',
      category: 'mobile',
      icon: 'fas fa-laptop-code',
      image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80',
      description: 'Modern, fast, and responsive web applications built with Next.js, React 18, and enterprise high-concurrency backends.',
      tags: ['Next.js / React', 'Node.js', 'Sub-second Load'],
      color: '#8B5CF6',
    },
    {
      id: 'ai-ml',
      title: 'AI Models & Machine Learning',
      category: 'ai',
      icon: 'fas fa-brain',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80',
      description: 'Intelligent AI models, predictive analytics engines, LLM integrations, and custom RAG agents that automate complex business tasks.',
      tags: ['Generative AI', 'LLM Agents', 'Predictive ML'],
      color: '#10B981',
    },
    {
      id: 'ai-automation',
      title: 'AI Workflow Automation & RPA',
      category: 'ai',
      icon: 'fas fa-robot',
      image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80',
      description: 'Autonomous AI agents, robotic process automation (RPA), smart document processing, and automated workflow bots that optimize operations.',
      tags: ['RPA Automation', 'AI Workflow Bots', 'Document Extraction'],
      color: '#F59E0B',
    },
    {
      id: 'social-growth',
      title: 'Social Media Management & Digital Growth',
      category: 'growth',
      icon: 'fas fa-bullhorn',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=800&q=80',
      description: 'Data-driven social media management, brand strategy, automated content pipelines, performance marketing, and high-ranking search engine SEO.',
      tags: ['Social Media Mgmt', 'Digital Marketing', 'SEO Growth'],
      color: '#EC4899',
    },
    {
      id: 'cloud-devops',
      title: 'Cloud Infrastructure & DevOps',
      category: 'cloud',
      icon: 'fas fa-cloud-upload-alt',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80',
      description: 'Zero-downtime cloud migration, Kubernetes orchestration, CI/CD automation pipelines, and managed infrastructure on AWS & GCP.',
      tags: ['AWS & GCP', 'Kubernetes', 'CI/CD Pipelines'],
      color: '#38BDF8',
    },
    {
      id: 'fintech',
      title: 'FinTech Platforms & PaperLoan',
      category: 'core',
      icon: 'fas fa-shield-alt',
      image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=800&q=80',
      description: 'Secure digital lending engines, instant e-KYC underwriting, payment gateways, wallet management, and banking API switches.',
      tags: ['PaperLoan Engine', 'e-KYC & Underwriting', 'Payment Switch'],
      color: '#10B981',
    },
    {
      id: 'erp-crm',
      title: 'Enterprise ERP & CRM Systems',
      category: 'core',
      icon: 'fas fa-chart-network',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80',
      description: 'Custom ERP and CRM platforms to streamline business operations, automated customer tracking, and real-time inventory workflows.',
      tags: ['Operational ERP', 'Custom CRM', 'Inventory Workflow'],
      color: '#A855F7',
    },
    {
      id: 'api-integration',
      title: 'API Engineering & Banking Gateway',
      category: 'core',
      icon: 'fas fa-project-diagram',
      image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80',
      description: 'Seamless integration with third-party APIs, legacy enterprise databases, payment gateways, and high-speed banking switches.',
      tags: ['REST & GraphQL', 'Bank Switch APIs', 'Low Latency'],
      color: '#00D4FF',
    },
    {
      id: 'cyber-security',
      title: 'Cyber Security & Compliance',
      category: 'cloud',
      icon: 'fas fa-user-shield',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80',
      description: 'End-to-end security audits, threat assessment, data encryption, SOC2 compliance, and continuous vulnerability penetration testing.',
      tags: ['SOC2 Compliant', 'Penetration Testing', 'Data Encryption'],
      color: '#EF4444',
    },
    {
      id: 'ui-ux',
      title: 'UI/UX Design & Product Strategy',
      category: 'mobile',
      icon: 'fas fa-paint-brush',
      image: 'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&w=800&q=80',
      description: 'Award-winning product design, user research, interactive wireframes, and design systems crafted for maximum conversion and retention.',
      tags: ['Design Systems', 'User Research', 'Conversion Design'],
      color: '#8B5CF6',
    },
  ];

  const filteredServices = filter === 'all' 
    ? services 
    : services.filter(s => s.category === filter);

  return (
    <section
      id="services"
      style={{
        padding: '64px 0',
        position: 'relative',
        zIndex: 2,
        background: '#060816',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">OUR SERVICES</span>
          <h2 className="text-gradient" style={{ fontSize: 'clamp(2.2rem, 3.8vw, 3.2rem)', fontWeight: 800 }}>
            End-to-End Software Development Services
          </h2>
          <p style={{ color: '#A3A8B8', fontSize: '1.1rem', maxWidth: '750px', margin: '14px auto 0 auto' }}>
            We empower startups and global enterprises with cutting-edge software engineering, AI automation, mobile app development, and digital growth services.
          </p>

          {/* Filter Pills */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap', marginTop: '32px' }}>
            {[
              { id: 'all', label: 'All Services' },
              { id: 'ai', label: 'AI & Automation' },
              { id: 'mobile', label: 'iOS & Mobile Apps' },
              { id: 'core', label: 'FinTech & Core ERP' },
              { id: 'cloud', label: 'Cloud & Security' },
              { id: 'growth', label: 'Digital Growth & SEO' },
            ].map((btn) => (
              <button
                key={btn.id}
                onClick={() => setFilter(btn.id)}
                style={{
                  padding: '10px 22px',
                  borderRadius: '9999px',
                  border: filter === btn.id ? '1px solid #00D4FF' : '1px solid rgba(255, 255, 255, 0.1)',
                  background: filter === btn.id ? 'rgba(0, 212, 255, 0.15)' : 'rgba(255, 255, 255, 0.03)',
                  color: filter === btn.id ? '#00D4FF' : '#A3A8B8',
                  fontSize: '0.88rem',
                  fontWeight: 700,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                  boxShadow: filter === btn.id ? '0 0 20px rgba(0, 212, 255, 0.25)' : 'none',
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>

        {/* Services Grid (Desktop: 4 cols, Tablet: 2 cols, Mobile: 1 col) */}
        <div
          className="services-grid-responsive"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '24px',
          }}
        >
          {filteredServices.map((service) => (
            <div
              key={service.id}
              className="glass-card"
              style={{
                borderRadius: '24px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(23, 32, 54, 0.95)';
                e.currentTarget.style.borderColor = `${service.color}80`;
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = `0 20px 40px rgba(0, 0, 0, 0.6), 0 0 30px ${service.color}35`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(15, 23, 42, 0.75)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Cover Image Header with Image Tag & Gradient Overlay */}
              <div style={{ position: 'relative', height: '170px', overflow: 'hidden', backgroundColor: '#0F172A' }}>
                <img
                  src={service.image}
                  alt=""
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.5s ease',
                  }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 20%, rgba(15, 23, 42, 0.95) 100%)' }}></div>
                
                {/* Glowing Floating Icon Badge Overlay */}
                <div
                  style={{
                    position: 'absolute',
                    bottom: '12px',
                    left: '20px',
                    width: '46px',
                    height: '46px',
                    borderRadius: '14px',
                    background: 'rgba(6, 8, 22, 0.88)',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    border: `1px solid ${service.color}70`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: service.color,
                    fontSize: '1.2rem',
                    boxShadow: `0 0 20px ${service.color}40`,
                    zIndex: 2,
                  }}
                >
                  <i className={service.icon}></i>
                </div>
              </div>

              {/* Card Body */}
              <div style={{ padding: '20px 18px 18px 18px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  {/* Card Title */}
                  <h3
                    style={{
                      fontSize: '1.18rem',
                      color: '#FFFFFF',
                      marginBottom: '10px',
                      fontWeight: 800,
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      letterSpacing: '-0.02em',
                      lineHeight: 1.3,
                    }}
                  >
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p
                    style={{
                      fontSize: '0.88rem',
                      color: '#A3A8B8',
                      lineHeight: 1.6,
                      marginBottom: '16px',
                      fontFamily: "'Inter', sans-serif",
                    }}
                  >
                    {service.description}
                  </p>

                  {/* Feature Tags */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '20px' }}>
                    {service.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        style={{
                          padding: '4px 9px',
                          borderRadius: '6px',
                          background: 'rgba(255, 255, 255, 0.04)',
                          border: '1px solid rgba(255, 255, 255, 0.08)',
                          color: '#CBD5E1',
                          fontSize: '0.72rem',
                          fontWeight: 600,
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Card Bottom CTA Button */}
                <div
                  onClick={onOpenConsultation}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '9999px',
                    background: `${service.color}15`,
                    border: `1px solid ${service.color}40`,
                    color: service.color,
                    fontWeight: 700,
                    fontSize: '0.84rem',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    cursor: 'pointer',
                    width: 'fit-content',
                    transition: 'all 0.25s ease',
                  }}
                >
                  <span>Consult on this</span>
                  <i className="fas fa-arrow-right" style={{ fontSize: '0.72rem' }}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .services-grid-responsive {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 16px !important;
          }
        }
        @media (max-width: 640px) {
          .services-grid-responsive {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;


